import { Controller } from "stimulus";
import Calendar from 'js-year-calendar';
import 'js-year-calendar/locales/js-year-calendar.pt';
import EventService from "../entrypoints/src/admin/services/event-service";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";
import FormSimulate from "../entrypoints/src/admin/components/form_simulate";
import Swal from "sweetalert2";

export default class extends Controller {
  static targets = [ 'modalEvents', 'modalEventsTitle', 'modalEventsList', 'modalEditEvent', 'modalEditEventTitle', 'destroyButton' ];

  static values = {
    date: String,
    year: String,
    newEventUrl: String,
    editEventUrl: String,
    showEventUrl: String
  }

  connect() {
    if (!Calendar)
      return;

    this.element.querySelectorAll('.toggle-filter').forEach(($el) => {
      if (!$el.dataset.listeningEvent)
        $el.addEventListener('click', (ev) => { this.element.querySelector('.filters').classList.toggle('in') } )
      $el.dataset.listeningEvent = true;
    });

    this.calendar = new Calendar('#calendar', {
      enableContextMenu: true,
      enableRangeSelection: true,
      language: 'pt',
      displayHeader: false,
      contextMenuItems:[
        { text: 'Remover', click: this.deleteEvent.bind(this) }
      ],
      selectRange: (e) => this.selectRange(e),
      clickDay: (e) => this.onCalendarClickDay(e)
    });

    this.updateDataSource(this.yearValue);
  }

  onCalendarClickDay(e) {
    if (e.events.length == 0) {
      this.newEvent(e);
    } else {
      this.showEventModal(e);
    }
  }

  showEventModal(e) {
    let optionsLocale = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    this.modalEventsTitleTarget.innerHTML = `Eventos de ${e.date.toLocaleDateString('pt-BR', optionsLocale)}`;
    let htmlEventLists = e.events.reduce((eventsHTML, event) => {
      return eventsHTML.concat(`
        <li class="list-group-item list-group-item-action cursor-pointer shadow-sm border rounded" data-action="click->calendar-events#editEvent" data-event-id="${event.id}">
          <div class="event-name">${event.name} (${event.day === 'holiday' ? 'Feriado' : 'Evento'})</div>
          <div class="text-sm text-black text-left mb-1"><i class="fas fa-clock text-xs"></i> ${event.startDate.toLocaleDateString('pt-BR', optionsLocale)} ${!!event.endDate ? ` até ${event.endDate.toLocaleDateString('pt-BR', optionsLocale)}` : ''}</div>
          <div class="event-description mt-2">
            ${!!event.description ? event.description : '<span class="text-muted">Sem descrição para esse evento</span>'}
          </div>
        </li>
      `);
    }, '');
    this.modalEventsListTarget.innerHTML = `<ul class="list-group list-group-flush">${htmlEventLists}</ul>`;
    $(this.modalEventsTarget).modal('show');
  }

  findEventById(id) {
    return this.events.find((event) => event.id == +id);
  }

  printEventsToSidePanel(events) {
    let optionsLocale = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    let htmlLists = events.reduce((html, event) => {
      return html.concat(`<li class="list-group-item list-group-item-action cursor-pointer" data-action="click->calendar-events#editEvent" data-event-id="${event.id}">
        <div class="font-medium" ${!!event.color ? `style="color: ${event.color}"` : ''}>${event.name}</div>
        <div class="text-sm text-black text-left mb-1"><i class="fas fa-clock text-xs"></i> ${event.startDate.toLocaleDateString('pt-BR', optionsLocale)} ${!!event.endDate ? ` até ${event.endDate.toLocaleDateString('pt-BR', optionsLocale)}` : ''}</div>
      </li>`);
    }, '');

    this.element.querySelector('#side-panel-event-lists').innerHTML = htmlLists.length == 0 ? '<span class="text-muted mt-3">Nenhum evento encontrado no período</span>' : `<ul class="list-group list-group-flush overflow-auto" style="height: calc(55vh - var(--menu-height))">${htmlLists}</ul>`;
  }

  selectRange(e) {
    if(!!e.startDate && !!e.endDate && e.startDate != e.endDate)
      return this.newEvent(e);
  }

  async newEvent(e) {
    await this.showEventForm(e);
    let $elStartDate = this.element.querySelector('turbo-frame#event-form form input[name="event[start_date]"]'),
      date = e.date || e.startDate;
    !!$elStartDate && !!date && ($elStartDate.value = date.toLocaleDateString('pt-BR'));

    let $elEndDate = this.element.querySelector('turbo-frame#event-form form input[name="event[end_date]"]');
    !!$elEndDate && !!e.endDate && ($elEndDate.value = e.endDate.toLocaleDateString('pt-BR'));
  }

  deleteEvent(e) {
    this.askConfirmation().then(async (result) => {
      if (result.value) {
        let eventId = e.id || this.selectedEvent.id;
        FormSimulate.submit({
          method: 'delete',
          action: this.showEventUrlValue.replace('replace-me', eventId)
        });
      }
    });
  }

  editEvent(e) {
    this.showEventForm(e);
  }

  showEventForm(e) {
    return new Promise(async (resolve, reject) => {
      this.selectedEvent = this.findEventById(e.currentTarget.dataset.eventId);
      this.destroyButtonTarget.classList.toggle('hidden', !this.selectedEvent);
      AjaxLoader.show();

      let turboFrame = this.element.querySelector('turbo-frame#event-form');
      turboFrame.setAttribute('src', `${this.eventUrl(this.selectedEvent)}?tfid=event-form`);
      await turboFrame.loaded;

      $(this.modalEventsTarget).modal('hide');
      $(this.modalEditEventTarget).modal('show');
      this.modalEditEventTitleTarget.innerHTML = !this.selectedEvent ? 'Novo Evento' : this.selectedEvent.name;

      AjaxLoader.hide();
      resolve();
    });
  }

  eventUrl(event) {
    if (!!event && !!+event.id) {
      return this.editEventUrlValue.replace('replace-me', event.id);
    }

    return this.newEventUrlValue;
  }

  askConfirmation() {
    return Swal.fire({
      customClass: {
        cancelButton: 'btn btn-gray-primary mx-2',
        confirmButton: 'btn btn-danger mx-2'
      },
      buttonsStyling: false,
      title: 'Atenção',
      text: "Tem certeza que deseja remover esse evento?",
      type: 'warning',
      animation: false,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, tenho certeza'
    });
  }

  async updateDataSource(year) {
    this.events = await EventService.where({ queryParams: [`date=${this.dateValue}`]});
    this.events.map((event) => {
      let commonEventAttributes = {
        startDate: this.toDate(event.start_date),
        endDate: this.toDate(event.end_date || event.start_date),
      };

      if (!!event.level)
        commonEventAttributes.color = this.eventLevelColor()[event.level]

      return Object.assign(event, commonEventAttributes);
    });

    this.printEventsToSidePanel(this.events);
    this.calendar.setYear(year);
    this.calendar.setDataSource(this.events);
  }

  eventLevelColor() {
    return {
      'national': '#ff0606',
      'state': '#978500',
      'city': '#ff1fb1'
    }
  }

  toDate(date) {
    let [year, month, day] = date.split('-');
    return new Date(year, month - 1, day)
  }
}